<template>
<v-container fluid class="pa-0 ma-0" style="min-width:250px;max-width:250px">

    <v-row dense justify="center">
        <v-col >

          <v-menu 
            v-model="dialog_com"
            :close-on-content-click="false"
            offset-x left
            @input="menu_handler"
            >
            <template v-slot:activator="{ on }">
              <div v-on="on" style="cursor:pointer;" class="d-flex">
                <div class="fontselect d-flex ml-1">
                  <span class="me-auto" style="font-size:14px">{{ font != null ? font.NAME : '' }}</span>
                  <span class="mr-1 dropdown-icon">&#9662;</span>
                </div>
              </div>
            </template>
  
            <v-card class="ma-0 pa-1" 
                    style="width:100%;min-height:400px;max-height:700px;">
              
                <v-list ref="fontList" :lines="false" density="compact" nav style="background:white;" class="overflow-y-auto">
                  <v-list-item 
                    v-for="(element,index)  in itemList_com" class="pa-0 ma-0 pl-2"
                    :key="element.IDX" style="height:20px"
                    :id="`${did}_${index}`"
                    :value="element" :style="font.NAME == element.NAME ? 'background:#f0f0f0' : ''"
                    @click="selectfont(element)"
                    >
                    <label :style="'font-size:14px; font-family:'+element.CODE">
                      {{ element.NAME }}
                    </label>
                  </v-list-item>
                </v-list>
              
            <v-row dense justify="center" class="pa-0 ma-0">
              <v-col cols="11">
                <div style="background:gray;height:1px;" />
              </v-col>
            </v-row>
            <v-card-actions style="background:white">
              <v-row justify="center" dense>
                <v-col cols="12" align="center">
                  <v-btn variant="text" size="small" @click="close_com">닫기</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
  
          </v-menu>            


        </v-col>
    </v-row>

</v-container>
</template>

<script>
export default {

    props:{
      comidx: Number,
      obj:{type:Object, default:null},
      font: {type:Object, default:null},
      did:{type:String, default:()=>Math.random().toString(36).substring(2,15)}
    },

    setup(){

    },

    mounted(){
      this.backupfont();
      this.loadpage_com();
    },

    data: ()=> ({

        dialog_com : false,
        load_flag : false,

        //백업
        backup:{},

        itemList_com: [],
        search_keyword_com : '',

    }),

    updated(){
      
      if(this.dialog_com){
        if(!this.load_flag && this.itemList_com.length == 0 && this.search_keyword_com.length == 0){
          this.load_flag = true;
          this.loadpage_com();
        }

        this.scrollFont();

      }else{
        this.load_flag = false;
      }

    },



    methods: {

      backupfont(){
        //처음 폰트데이터를 백업한다.
        this.backup = this.font;
      },

      selectfont(element){
        this.$emit('callback', element, this.font);
        //콜백 호출 후 닫아야함.
        this.dialog_com = false
        this.select_com = [];
        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
        this.search_keyword_com = '';
      },

      scrollFont(){

        const index = this.itemList_com.findIndex(item => item.NAME === this.font.NAME);
        if(index !== -1){
          console.log(`index: ${index}`);
          setTimeout(() => {
            document.getElementById(`${this.did}_${index}`).scrollIntoView({behavior: 'auto', block:'center'});
          }, 100); // 약간의 지연 시간          
        }

      },

      loadpage_com(){

        console.log(`font loadpage_com`);

          this.$http.post(this.$host+'/api/DialogFontList',{
            search_keyword: this.search_keyword_com == null || this.search_keyword_com == undefined ?  '' : escape(this.search_keyword_com)
          , sort_name: 'NAME'
          , sort_type: "DESC"
          , page: 1
          , pagerow: 99999
          , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX: this.comidx
          , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
              this.load_flag = true;
              if(result.data.resultCode == 0){

                  //토큰 저장
                  if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                    this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                  }
                  if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                    this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                  }

                  const list = result.data.resultData;
                  this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                  list.forEach(element => {
                    this.itemList_com.push(element); 
                    //폰트 등록
                    var temp_font = new FontFace(element.NAME, "url('"+element.FONTURL+"')");
                    document.fonts.add(temp_font);
                  });

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              
          });

      },      

        //다이얼로그 닫기
        close_com () {
          this.dialog_com = false
        },

        menu_handler(){
            //console.log("menu_handler");
            //최초 또는 메뉴 외곽 클릭시 
            //텍스트값 백업
            this.backup  = this.font;
        },


    }


}
</script>

<style scoped>
.fontselect{
  width:100%;
  border: 1px gray solid; 
  border-radius:5px; 
  padding-left:5px;
  font-size:14px;
  line-height: 28px;
  height:28px;
  font-weight: bold;
}
.dropdown-icon {
  margin-left: 10px;
  color: #333333;
  font-size: 28px;
}
</style>